import SearchBar from '@/vuetify_custom/v-form'
import moment from 'moment'
import { 
    VTabs,
    VTab,
    VTabsItems,
    VTabItem
  } from 'vuetify/lib'
  import Statement from './Statement'
  import {account_type_list, cbs_type_list} from './fields'
export default {
    data() {
        return {
            tab: 0,
            search_bar_height: 149,
            params: {
                month: null,
                company_id: null,
                is_cbs: false,
                search_key: null,
                settle_type: null,
              },
              saving: false
        }
    },
    computed: {
      table_height() {
        return this.containHeight - this.search_bar_height
      },
      containHeight() {
        const window_height = this.$store.state.window_height;
        return window_height - 180;
      },
        searchFields() {
          const proxyGetData = this.proxyGetData
            const arr = [
                {
                    label: '公司',
                    type: 'company_select',
                    key: 'company_id',
                    cols: 2,
                    clearable:true,
                    change: proxyGetData,
                },
                {
                  label: '',
                  type: 'select_field_v1',
                  key: 'is_cbs',
                  cols: 2,
                  clearable:true,
                  change: proxyGetData,
                  items: cbs_type_list,
                },
                {
                  label: '结算类型',
                  type: 'select_field_v1',
                  key: 'settle_type',
                  cols: 2,
                  clearable:true,
                  items: account_type_list,
                  change: proxyGetData,
                },
                {
                  key: 'search_key',
                  cols: 3,
                  clearable:true,
                  'append-icon':'mdi-magnify',
                  placeholder: '请输入搜索内容',
                  'click:append': proxyGetData,
                  'keydown.enter':proxyGetData,
                  'click:clear': proxyGetData,
                },
            ]
            return arr
        }
    },
    created() {
      const { month, settle_type } = this.$route.query
      if (month !== moment(month).format('YYYY-MM')) { // 当月份参数不对时回退
        this.$router.replace('dashBoard/fundsmonitoring/fin')
      }
      this.params.settle_type = settle_type || null
      this.params.month = month
      this.proxyGetData()
    },
    mounted() {
      this.search_bar_height = this.$refs['search-bar'].offsetHeight
    },
    methods: {
      proxyGetData() {
        this.$nextTick(() => {
         this.getData()
        })
      },
      getData() {
        this.$refs[`${this.tab}`].getData()
      },
    },
    render() {
        const _this = this
        return <div ref="contain" style={{
          height: _this.containHeight + 'px',
          overflow: 'hidden'
        }}>
          <div ref="search-bar">
            <h2 style="text-align: center">{this.params.month}-境内人民币资金流水明细-单位（元）</h2>
              <SearchBar
              v-model={_this.params}
              fields={_this.searchFields}
              />
              <VTabs v-model={_this.tab}>
                  <VTab>流水明细</VTab>
              </VTabs>
          </div>
            <VTabsItems v-model={_this.tab}>
                <VTabItem>
                    <div>
                        <Statement 
                          ref="0"
                          outParams={_this.params}
                          tableHeight={_this.table_height}
                        />
                    </div>
                </VTabItem>
            </VTabsItems>
        </div>
    }
}